import { IActionLinkItems } from '../ActionLinkModels';

export const hasNesting = (values: IActionLinkItems) => values.nested && !!values.nested.size;
